import styled from 'styled-components'

const Heading = styled.div<HeadingProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: none;
  justify-content: space-between;
  @media(max-width: 767px) {
    flex-wrap: wrap;
  }
  align-items: center;
  width: 100%;
  height: auto;
  min-height: 48px;
  background: #FFFFFF;
  box-sizing: border-box;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #E1E1E1;
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: #E1E1E1;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #E1E1E1;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #E1E1E1;
  ${({ collapse }) => collapse ? `
    border-radius: 5px;
  ` : `
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  `}
`

export default Heading

export interface HeadingProps {
  collapse: boolean
}